module.exports = __webpack_public_path__ + "static/media/profile.e35853ab.png";